const validChildren = ['CryptoIcon', 'FiatIcon', 'FileIcon', 'IconBadge', 'MerchantIcon', 'VisualElementGroup'];

export { validChildren };
